import { isElectron } from '../..';
import { getSharedStores } from '../../stores/shared';
import { getIpcFunctions } from '../ipcInterface';
import { initializeAllGamepads } from './gamepadEvents';
import * as Sentry from '@sentry/react';
import { machineNameState } from '../../stores/shared';
import constants from '@playcastdotio/GlobalConfig';

const initialCooldown = 5000;
const waitTimeout = 4500;
let shouldHandle = false;
setTimeout(() => {
  shouldHandle = true;
}, initialCooldown);
let pendingRestart: NodeJS.Timeout | null = null;

export const handlePlayjectorCrash = () => {
  if (!shouldHandle || !isElectron) {
    return;
  }
  const state = getSharedStores();
  console.warn('Playjector crashed!');

  // Ad Mode: Send Sentry event for Playjector crash
  const isAdMode = state.adModeState.currentState.enabled;
  const isPavilion = state.hostState.currentState.edition === 'pavilion';
  const isStreaming = state.hostState.currentState.status === 'streaming';

  if (isAdMode && isPavilion) {
    console.error('[Ad Mode] 💥 Playjector crashed');

    const machineId = state.machineIdState.currentState || 'unknown';
    const machineName = machineNameState.currentState || 'unknown';

    Sentry.captureMessage('Ad Mode: Playjector Crashed', {
      level: 'error',
      tags: {
        crash_type: 'playjector_crash',
        was_streaming: String(isStreaming),
        machine_id: machineId,
        machine_name: machineName,
        version: constants.VERSION,
      },
      extra: {
        adModeEnabled: isAdMode,
        steamId: state.adModeState.currentState.steamId,
        isStreaming,
        machineId,
        machineName,
        version: constants.VERSION,
        timestamp: Date.now(),
      },
    });
  }

  const selectedDisplayId = state.displayState.currentState.info.selectedDisplayId;
  console.warn('Selected display:', selectedDisplayId);
  pendingRestart = setTimeout(() => {
    // If we are streaming, re-initialize the gamepads.
    if (isStreaming) {
      initializeAllGamepads();
    }
    // If we have a display selected, re-select it.
    if (selectedDisplayId !== -1) {
      getIpcFunctions().changeDisplay(selectedDisplayId);
    }
  }, waitTimeout);
};

export const setShouldHandlePlayjectorCrash = (shouldHandleCrash: boolean) => {
  shouldHandle = shouldHandleCrash;
  if (!shouldHandle) {
    if (pendingRestart) {
      clearTimeout(pendingRestart);
    }
  }
};
